import InfoPanel from "./InfoPanel.jsx";
import Logo from "./Logo.jsx";
import UserMenu from "./UserMenu.jsx";

function AppHeader({ currentUser, setCurrentUser }) {
  return (
    <header className="app-header">
      <Logo />
      <InfoPanel />
      <UserMenu user={currentUser} setCurrentUser={setCurrentUser} />
    </header>
  );
}

export default AppHeader;
